const trackedRequests = {};
export default trackedRequests;